import React, { FC } from 'react';

import styles from './TitleRowCard.module.scss';

interface ContentTypes {
  title: string;
  description: string;
}

interface Props {
  title: string;
  contents: ContentTypes[];
}

const TitleRowCard: FC<Props> = (props) => {
  const { title, contents } = props;

  const contentsNode = Array.isArray(contents) && contents.length && (
    <div className={styles['title-row-card-content-wrap']}>
      {contents.map((item, idx) => (
        <div className={styles['title-row-card-content-item']} key={idx}>
          {item.title && <div className={styles['title-row-card-content-item-title']}>{item.title}</div>}
          {item.title && <div className={styles['title-row-card-content-item-desc']}>{item.description}</div>}
        </div>
      ))}
    </div>
  );

  return (
    <div className={styles['title-row-card-wrap']}>
      <div className={styles['title-row-card-container']}>
        {title && <div className={styles['title-row-card-title']}>{title}</div>}
        {contentsNode}
      </div>
    </div>
  );
};

TitleRowCard.displayName = 'TitleRowCard';
TitleRowCard.defaultProps = {
  title: '',
  contents: [],
};

export default TitleRowCard;
